import angular from 'angular';
import onboardingIndividualDetails from './onboardingIndividualDetails';

export default angular
  .module('components.onboardingIndividualDetails', [])
  .component('onboardingIndividualDetails', onboardingIndividualDetails).name;
